import { IInterval } from "../../../../Context/Interval";
import { ISystemContext } from "../../../../Context/SystemContext";
import { PixiSpriteResource } from "../../../../ResourceManager/PixiSpriteResource";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { CanvasSprite } from "../../../../slot/Sprite/CanvasSprite";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { LogGroup, CreateElement, Scale, Size } from "../../../.././MyHelpers";
import { Slide, SlideFactory2Params } from "./Slide";
import { Settings, JackpotDisplayType } from "../../../../Settings";


export class HoldAndSpinLeft extends Slide {

	protected logGroup: LogGroup;
	protected resid: ResourceIdentifier;
	protected systemContext: ISystemContext;

    protected SripiteTimer: IInterval;
    protected SpriteLeft: CanvasSprite = null;
    protected SripiteTimerLeft: IInterval;

    constructor(initData: SlotGameInitData, p: SlideFactory2Params , viewSize : Size) {
		super(initData, p , viewSize);
		
		this.logGroup = 	 this.p.logGroup.Add("HoldAndSpinLeft");
		this.resid = 		 this.p.resid.Add("HoldAndSpinLeft");
		this.systemContext = this.p.systemContext.CreateSubContext("HoldAndSpinLeft");
        this.viewSize = viewSize;

        this.view = CreateElement("div", {
            classes: ["HoldAndSpinLeft", this.resid.Scope()],
            style: {
                position: "absolute",
                height: viewSize.Height+"px",
                width: viewSize.Width+"px",

                display: "flex",
                flexDirection: "column",
                flexShrink: "0",
            }
        });
    }


    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        let ChangeFilepath = this.path + "Slider2/StickySpinLeft-"+Settings.JackpotDisplayType.toString();
        this.PrepareStickySpinSlide(resourceManager , ChangeFilepath);
    }

    public PrepareStickySpinSlide(resourceManager : IWriteOnlyResourceManager , path){
        resourceManager.Add(new PixiSpriteResource(path, ResourceIdentifier.Global.Add(this.initData.GameName + "StickySpinLeft").Add("StickySpinLeft"), true, this.logGroup.Add("StickySpinLeft"), true));
    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {


        this.SpriteLeft = new CanvasSprite({sprite: resourceManager.Get<PixiSpriteResource>(ResourceIdentifier.Global.Add(this.initData.Name + "StickySpinLeft").Add("StickySpinLeft")).sprite, canvasSize: new Size( this.viewSize.Width , this.viewSize.Height)});
        //this.SpriteFreegame.ScaleNonUniform(1.1, 1.2);
        this.SpriteLeft.View().style.position = "relative";

        this.view.appendChild(this.SpriteLeft.View());


        this.SripiteTimerLeft = this.systemContext.TimingContext().CreateInterval("StickySpinLeft", this.nextAnimInterval, () => this.SpriteLeft.Start(false));




    }


    public override View(): HTMLElement {
        return this.view;
    }
    public override Update() {

        this.SpriteLeft.Update();
    }
    public override Start() {

        this.SripiteTimerLeft.Start();
    }

    public override Stop() {

		this.SripiteTimerLeft.Stop();
		this.SpriteLeft.StopAndReset();

    }
}
